
FCS		= require "fcs"


Buffer 	= require('buffer/').Buffer 
facsId=0
class FacsChart

	constructor: (data) ->

		@id			= facsId
		@scale		= 0.75

		facsId++
		window.activePlasmid = this
		@ob 			= null	#drawing object
		@obCopy			= $("<textarea/>").appendTo("body") 
		@obCopy.css 
			position:"absolute"
			top:"-100px"
			left:"-100px"
		@df=[{"name":"AmpR (3)","typ":"feature","bp":"ATGAGTATTCAACATTTCCGTGTCGCCCTTATTCCCTTTTTTGCGGCATTTTGCCTTCCTGTTTTTGCTCACCCAGAAACGCTGGTGAAAGTAAAAGATGCTGAAGATCAGTTGGGTGCACGAGTGGGTTACATCGAACTGGATCTCAACAGCGGTAAGATCCTTGAGAGTTTTCGCCCCGAAGAACGTTTTCCAATGATGAGCACTTTTAAAGTTCTGCTATGTGGCGCGGTATTATCCCGTGTTGACGCCGGGCAAGAGCAACTCGGTCGCCGCATACACTATTCTCAGAATGACTTGGTTGAGTACTCACCAGTCACAGAAAAGCATCTTACGGATGGCATGACAGTAAGAGAATTATGCAGTGCTGCCATAACCATGAGTGATAACACTGCGGCCAACTTACTTCTGACAACGATCGGAGGACCGAAGGAGCTAACCGCTTTTTTGCACAACATGGGGGATCATGTAACTCGCCTTGATCGTTGGGAACCGGAGCTGAATGAAGCCATACCAAACGACGAGCGTGACACCACGATGCCTGCAGCAATGGCAACAACGTTGCGCAAACTATTAACTGGCGAACTACTTACTCTAGCTTCCCGGCAACAATTAATAGACTGGATGGAGGCGGATAAAGTTGCAGGACCACTTCTGCGCTCGGCCCTTCCGGCTGGCTGGTTTATTGCTGATAAATCTGGAGCCGGTGAGCGTGGGTCTCGCGGTATCATTGCAGCACTGGGGCCAGATGGTAAGCCCTCCCGTATCGTAGTTATCTACACGACGGGGAGTCAGGCAACTATGGATGAACGAAATAGACAGATCGCTGAGATAGGTGCCTCACTGATTAAGCATTGGTAA"},{"name":"CAP binding site","typ":"feature","bp":"TAATGTGAGTTAGCTCACTCAT"},{"name":"KanR","typ":"feature","bp":"ATGGCAATTACCTTATCCGCAACTTCTTTACCTATTTCCGCCCGGATCCGGGCAGGTTCTCCGGCCGCTTGGGTGGAGAGGCTATTCGGCTATGACTGGGCACAACAGACAATCGGCTGCTCTGATGCCGCCGTGTTCCGGCTGTCAGCGCAGGGGCGCCCGGTTCTTTTTGTCAAGACCGACCTGTCCGGTGCCCTGAATGAACTGCAGGACGAGGCAGCGCGGCTATCGTGGCTGGCCACGACGGGCGTTCCTTGCGCAGCTGTGCTCGACGTTGTCACTGAAGCGGGAAGGGACTGGCTGCTATTGGGCGAAGTGCCGGGGCAGGATCTCCTGTCATCTCACCTTGCTCCTGCCGAGAAAGTATCCATCATGGCTGATGCAATGCGGCGGCTGCATACGCTTGATCCGGCTACCTGCCCATTCGACCACCAAGCGAAACATCGCATCGAGCGAGCACGTACTCGGATGGAAGCCGGTCTTGTCGATCAGGATGATCTGGACGAAGAGCATCAGGGGCTCGCGCCAGCCGAACTGTTCGCCAGGCTCAAGGCGCGCATGCCCGACGGCGAGGATCTCGTCGTGACCCATGGCGATGCCTGCTTGCCGAATATCATGGTGGAAAATGGCCGCTTTTCTGGATTCATCGACTGTGGCCGGCTGGGTGTGGCGGACCGCTATCAGGACATAGCGTTGGCTACCCGTGATATTGCTGAAGAGCTTGGCGGCGAATGGGCTGACCGCTTCCTCGTGCTTTACGGTATCGCCGCTCCCGATTCGCAGCGCATCGCCTTCTATCGCCTTCTTGACGAGTTCTTCTGA"},{"name":"M13 fwd","typ":"feature","bp":"GTAAAACGACGGCCAGT"},{"name":"SV40 ori","typ":"feature","bp":"ATCCCGCCCCTAACTCCGCCCAGTTCCGCCCATTCTCCGCCCCATGGCTGACTAATTTTTTTTATTTATGCAGAGGCCGAGGCCGCCTCGGCCTCTGAGCTATTCCAGAAGTAGTGAGGAGGCTTTTTTGGAGGCC"},{"name":"T7 promoter","typ":"feature","bp":"TAATACGACTCACTATAGG"},{"name":"M13 rev","typ":"feature","bp":"CAGGAAACAGCTATGAC"},{"name":"SV40 poly(A) signal (2)","typ":"feature","bp":"AACTTGTTTATTGCAGCTTATAATGGTTACAAATAAAGCAATAGCATCACAAATTTCACAAATAAAGCATTTTTTTCACTGCATTCTAGTTGTGGTTTGTCCAAACTCATCAATGTATCTTATCATGTCTGGATC"},{"name":"T3 promoter","typ":"feature","bp":"AATTAACCCTCACTAAAGG"},{"name":"lac UV5 promoter","typ":"feature","bp":"TTTACACTTTATGCTTCCGGCTCGTATAATG"},{"name":"lac operator (2)","typ":"feature","bp":"GGAATTGTGAGCGGATAACAATTCC"},{"name":"ori","typ":"feature","bp":"TTGAGATCCTTTTTTTCTGCGCGTAATCTGCTGCTTGCAAACAAAAAAACCACCGCTACCAGCGGTGGTTTGTTTGCCGGATCAAGAGCTACCAACTCTTTTTCCGAAGGTAACTGGCTTCAGCAGAGCGCAGATACCAAATACTGTCCTTCTAGTGTAGCCGTAGTTAGGCCACCACTTCAAGAACTCTGTAGCACCGCCTACATACCTCGCTCTGCTAATCCTGTTACCAGTGGCTGCTGCCAGTGGCGATAAGTCGTGTCTTACCGGGTTGGACTCAAGACGATAGTTACCGGATAAGGCGCAGCGGTCGGGCTGAACGGGGGGTTCGTGCACACAGCCCAGCTTGGAGCGAACGACCTACACCGAACTGAGATACCTACAGCGTGAGCTATGAGAAAGCGCCACGCTTCCCGAAGGGAGAAAGGCGGACAGGTATCCGGTAAGCGGCAGGGTCGGAACAGGAGAGCGCACGAGGGAGCTTCCAGGGGGAAACGCCTGGTATCTTTATAGTCCTGTCGGGTTTCGCCACCTCTGACTTGAGCGTCGATTTTTGTGATGCTCGTCAGGGGGGCGGAGCCTATGGAAA"},{"name":"AmpR promoter (2)","typ":"feature","bp":"CGCGGAACCCCTATTTGTTTATTTTTCTAAATACATTCAAATATGTATCCGCTCATGAGACAATAACCCTGATAAATGCTTCAATAATATTGAAAAAGGAAGAGT"},{"name":"M13 ori (3)","typ":"feature","bp":"ACGCGCCCTGTAGCGGCGCATTAAGCGCGGCGGGTGTGGTGGTTACGCGCAGCGTGACCGCTACACTTGCCAGCGCCCTAGCGCCCGCTCCTTTCGCTTTCTTCCCTTCCTTTCTCGCCACGTTCGCCGGCTTTCCCCGTCAAGCTCTAAATCGGGGGCTCCCTTTAGGGTTCCGATTTAGTGCTTTACGGCACCTCGACCCCAAAAAACTTGATTTGGGTGATGGTTCACGTAGTGGGCCATCGCCCTGATAGACGGTTTTTCGCCCTTTGACGTTGGAGTCCACGTTCTTTAATAGTGGACTCTTGTTCCAAACTGGAACAACACTCAACCCTATCTCGGGCTATTCTTTTGATTTATAAGGGATTTTGCCGATTTCGG"}]
		@features		= [] 	#detected features 
		@history		= []	#cloning steps
		@name			= "Untiled"
		@author			= ""	#author of plasmid
		@description	= ""	#description of plasmid

		@displayOptions = 
			editable: false #edit dna
			features: true	#show features
			cutters: true	#show restriction enzymes
			primers: false	#show primers
			linear: false 	#display as vector or linear dna

		@center		= [400,400]
		@radius     = 250



		databuf=Buffer(data,"utf16");
		options=
				dataFormat:"asNumber"
				eventsToRead:-1
				
		fcs = new FCS(options, databuf);
		console.log fcs.text
		@min		= fcs.get$PnX("E")
		@max		= fcs.get$PnX("R")

		console.log @max,@min

		@axis		= fcs.get$PnX("N")
		@axisName 	= fcs.get$PnX("S") 	
		@dataPoints = fcs.dataAsNumbers
	draw: (id) ->
		self=this
		###
		@svg = raphael.generate(1000, 1000,(paper)->
			self.drawSVG(paper)
		)
		###
		@width=500
		@height=500	
		paper=Raphael(id,@width,@height);

		@ob=$("#"+id)
		@ob.find("svg").svg()

		@svgOb=@ob.find("svg").svg("get")	
		@ob.find("svg").css
			"transform": "scale("+@scale+")"
			"transform-origin":"top left"
			"float":"left"
		@ob.css
			width: @width*@scale+'px'
			height: @height*@scale+'px'	


		paper.path("M0 500 L500 500");
		paper.path("M0 500 L0 0");
		paper.path("M500 0 L500 500");
		paper.path("M500 0 L0 0");
		i=0	
		for point in @dataPoints
			i++
			paper.circle((point[2]/@max[2])*@width, @height-(point[4]/@max[4])*@width, 0.5);

			#paper.circle(Math.log10(point[0]), Math.log10(point[1]), 0.5);
		console.log Math.log10(i)	


module.exports=FacsChart